import React from "react";
import { OnboardingSteps } from "components";

function AddUncateringMeals() {
  return (
    <div className="w-full">
      <OnboardingSteps />
    </div>
  );
}

export default AddUncateringMeals;
